document.querySelectorAll('[data-lb-ref]').forEach(root=>{const tabs=[...root.querySelectorAll('[data-lb-tab]')];const activate=tab=>{tabs.forEach(t=>{const selected=t===tab;t.setAttribute('aria-selected',String(selected));t.tabIndex=selected?0:-1});root.querySelectorAll('[data-lb-panel]').forEach(p=>{p.hidden=p.dataset.lbPanel!==tab.dataset.lbTab})};tabs.forEach((tab,index)=>{tab.addEventListener('click',()=>activate(tab));tab.addEventListener('keydown',e=>{let target;if(e.key==='ArrowRight')target=tabs[(index+1)%tabs.length];if(e.key==='ArrowLeft')target=tabs[(index-1+tabs.length)%tabs.length];if(e.key==='Home')target=tabs[0];if(e.key==='End')target=tabs[tabs.length-1];if(target){e.preventDefault();activate(target);target.focus()}})})});
document.querySelectorAll('[data-lb-panel]').forEach(panel=>{
 let drag=null;
 let suppressClick=false;
 panel.addEventListener('dragstart',event=>event.preventDefault());
 panel.addEventListener('pointerdown',event=>{
  if(event.pointerType!=='mouse'||event.button!==0)return;
  suppressClick=false;
  drag={id:event.pointerId,x:event.clientX,left:panel.scrollLeft,moved:false};
 });
 panel.addEventListener('pointermove',event=>{
  if(!drag||event.pointerId!==drag.id)return;
  const distance=event.clientX-drag.x;
  if(!drag.moved&&Math.abs(distance)<8)return;
  if(!drag.moved){drag.moved=true;panel.setPointerCapture(event.pointerId);panel.classList.add('is-dragging')}
  event.preventDefault();
  panel.scrollLeft=drag.left-distance;
 });
 const finish=()=>{if(!drag)return;suppressClick=drag.moved;drag=null;panel.classList.remove('is-dragging')};
 panel.addEventListener('pointerup',finish);
 panel.addEventListener('pointercancel',finish);
 panel.addEventListener('lostpointercapture',finish);
 panel.addEventListener('pointerleave',()=>{if(drag&&!drag.moved)drag=null});
 panel.addEventListener('click',event=>{if(suppressClick){event.preventDefault();event.stopPropagation();suppressClick=false}},true);
});
